module.exports = require('./helpers/bundle-url').getBundleURL('scYWC') + "logo.c51670a8.svg";